import styled from 'styled-components'

export const MapTableContainerWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`

export const TableContainerWrapper = styled.div`
  height: 35%;
  flex: 0 0 auto;
  flex-direction: column;
  display: ${({ expanded }) => {
    return expanded ? 'flex' : 'none'
  }};
`

export const TableHeading = styled.div`
  width: 100%;
  height: 28px;
  flex-shrink: 0;
  background-color: rgba(10, 161, 244, 1);
  color: white;
  display: flex;
  padding-left: 12px;
  font-size: 14px;
  align-items: center;
`

export const TableContainer = styled.div`
  height: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  .esri-feature-table__content {
    flex: 1 1 auto;
  }
  position: relative;
`

export const MapWrapper = styled.div`
  width: 100%;
  height: 650px;
  flex: 1 1 auto;
`
